import * as React from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import { observer, inject } from 'mobx-react';
import { db } from '../firebase/firebase';
import '../sass/Tags.css';
import Tag from 'src/objects/Tag';

const KeyCodes = {
    comma: 188,
    enter: 13,
};
  
const delimiters = [KeyCodes.comma, KeyCodes.enter];

@inject("tagsStore")
@observer
export default class Tags extends React.Component<any, any> {

    private tagsRef:firebase.database.Reference = db.app.database().ref('settings').child('tags')

    constructor(props:any) {
        super(props);

        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        
        // this.tagsRef.on('value',function(snapshot) {
        //     let recommendedTags:Array<Tag> = []
        //     snapshot.forEach(function(item) {
        //         recommendedTags.push(item.val());
        //     });
        //     console.log(recommendedTags)
        //     this.setState({recommendedTags: recommendedTags})
        // }).bind(this);

        

        // this.props.tags.some(item => tag.id === item.id);
        // this.props.tagsStore.add(tag)
    }

    // updateInputValue = (evt) => {
    //     this.setState({
    //       inputValue: evt.target.value
    //     });
    // }
    
    // add = () => {
    //     this.props.tagsStore.add(this.state.tag)
    //     this.setState({
    //         inputValue: ''
    //     });
    // }

    handleDelete(i) {
        // const { tags } = this.props;
        // tags.filter((tag, index) => index !== i);
        let tags = this.props.tags;
        tags = tags.filter((tag, index) => index !== i);
        this.props.updateTags(tags)
        // this.setState({
        //  tags: tags.filter((tag, index) => index !== i),
        // });
    }

    handleAddition(tag:Tag) {
        let tags = this.props.tags;
        tags.push(tag)
        this.props.updateTags(tags)
        // this.setState(state => ({ tags: [...state.tags, tag] }));
        this.props.tagsStore.add(tag)
        // console.log("Tag", this.props.tagsStore.tags);
        // this.setState(state => ({ suggestions: [...state.suggestions, tag] }));
        
        this.tagsRef.once('value', function(snapshot) {
            if (snapshot.exists()) {
                console.log('exists');
                return;
            } else {
                this.tagsRef.push(tag);
            }
        }.bind(this));
    }

    handleDrag(tag, currPos, newPos) {
        const tags = this.props.tags;
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.props.updateTags(newTags)
        // this.setState({ tags: newTags });
    }

    // private onTagsUpdated() {
    //     // console.log("TAGS: ", this.props.tags)
    //     // const value = O2A(this.props.tags);
    //     let tags = this.props.tags
    //     var tagsArray = Object.keys(tags).map(function (i) {
    //         return tags[i];
    //     });
    //     this.setState({recommendedTags: tagsArray});
    // }

    render() {
        // const { tags } = this.state;
        const tagsStore = this.props.tagsStore;
        return (
            <div>
                <ReactTags tags={this.props.tags}
                    // suggestions={tagsStore.tags}
                    suggestions={this.props.recommendedTags}
                    handleDelete={this.handleDelete}
                    handleAddition={this.handleAddition}
                    handleDrag={this.handleDrag}
                    delimiters={delimiters} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Tags.tsx